import { useEffect, useState } from 'react';
import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import { useDataImport } from './context';
import { CalendarData } from './types';

/**
 * Tải dải lịch của một tháng (GET /data-import/calendar?month=YYYY-MM); tải lại khi đổi tháng
 * hoặc refreshKey tăng. Nhớ kèm tháng đã tải để lúc đổi tháng không hiện nhầm lịch tháng cũ.
 */
export function useCalendar(month: string, refreshKey: number) {
  const { reportError } = useDataImport();
  const [state, setState] = useState<{ month: string; data: CalendarData | null }>({
    month: '',
    data: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    AxiosUtils.get(API.dataImportCalendar, { month })
      .then((res: any) => {
        if (!cancelled) setState({ month, data: res?.data || null });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({ month, data: null });
        reportError(err, 'Không tải được lịch nhập');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [month, refreshKey, reportError]);

  const ready = state.month === month;
  return { data: ready ? state.data : null, loading: loading || !ready };
}
